import { render, staticRenderFns } from "./BJ.vue?vue&type=template&id=2ae68a6c&scoped=true&"
import script from "./BJ.vue?vue&type=script&lang=js&"
export * from "./BJ.vue?vue&type=script&lang=js&"
import style0 from "./BJ.vue?vue&type=style&index=0&id=2ae68a6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae68a6c",
  null
  
)

export default component.exports